import { AlertTriangle, CalendarDays } from 'lucide-react'
import type { WavePlanWeekHeader } from '@/api/wavePlans'
import { formatFullDate } from './model'

interface Props {
  weeks: WavePlanWeekHeader[]
  selectedId: string
  onSelect: (weekId: string) => void
}

/** The wave weeks of the DC view; a week outside the overall plan is called out. */
export function DcWaveSelector({ weeks, selectedId, onSelect }: Props) {
  const selected = weeks.find(week => week.id === selectedId)
  return (
    <>
      <section
        aria-label="Wave selection"
        className="flex min-w-0 items-center gap-2 overflow-x-auto py-1"
      >
        <CalendarDays
          size={15}
          className="shrink-0 text-muted-foreground"
          aria-label="Receipt wave"
        />
        {weeks.map((week, index) => (
          <button
            key={week.id}
            aria-pressed={week.id === selectedId}
            onClick={() => onSelect(week.id)}
            className={`dc-wave-tab cursor-pointer ${week.id === selectedId ? 'dc-wave-tab-active' : ''}`}
          >
            <span className="font-semibold">Wave {index + 1}</span>
            <span>{formatFullDate(week.date)}</span>
            {week.outside && <span>Outside plan</span>}
          </button>
        ))}
      </section>
      {selected?.outside && (
        <p
          role="status"
          className="flex items-center gap-2 rounded-md border border-amber-200 bg-amber-50 p-3 text-xs text-amber-900"
        >
          <AlertTriangle size={15} />
          This date is outside the overall plan. Retained SKU quantities and DC
          allocations still count.
        </p>
      )}
    </>
  )
}
